export default "__VITE_ASSET__d5gzeW5H__"